import './static/css/shared.css'
import './static/css/landing.css'
import './static/css/blog.min.css'
import './static/css/quick.css'
/*
const onClientEntry = () => {
  console.log('Started gatsby')
}

const onInitialClientRender = () => {
  console.log('Rendered gatsby')
}

const onRouteUpdate = () => {
  console.log('Updated route')
}

export { onClientEntry, onInitialClientRender, onRouteUpdate }
*/
